module.exports = __webpack_public_path__ + "img/clbanner.0d219c64.png";